import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Events from '../../api/Events';
import sSimg from '../../images/resource/ZArunachal.jpg';
import Subscribe2 from '../../components/Subscribe2/Subscribe2';
import Footer2 from '../../components/footer2/Footer2';
import VenueSection1 from '../../components/VenueSection/VenueSection1';

const EventSinglePage = (props) => {
    const { slug } = useParams()

    const eventDetails = Events[1];

    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-5'} topbarClass={'tb-block'} />
            <PageTitle pageTitle={eventDetails.eTitle} pagesub={'Event Details'} pageTitle2={'Event Details'}/>
            <section className="event-detail">
                <div className="auto-container">
                    <div className="inner-container">
                        <div className="event-detail_image">
                            <img src={sSimg} alt="" />
                        </div>
                        <div className="upper-box d-flex justify-content-between flex-wrap">
                            <h2 className="event-detail_title">{eventDetails.eTitle}</h2>
                            {/* <div className="event-detail_author">
                                <div className="event-detail_author-image">
                                    <img src={eventDetails.eImg} alt="" />
                                </div>
                                <div className="event-detail_author-name">{eventDetails.speaker}, <span>Art Critic</span></div>
                                <div className="event-detail_author-location"><span>Location:</span> Hall 1, Building, <br /> Golden Street , Southafrica</div>
                                <div className="event-detail_author-timing">08.00 am  09.00 am</div>
                                <div className="event-detail_author-icon flaticon-voice"></div>
                            </div> */}
                        </div>
                        <p>Zentara comes alive in Shergaon, Arunachal Pradesh—where mountains cradle conversations and crisp air clears the mind. This is not just a retreat, it’s a networking experience designed for thinkers, creators, and doers who believe connections are forged best in authentic spaces. Here, ideas are exchanged around bonfires, friendships are built in the rhythm of nature, and collaborations spark over shared meals and mindful sessions. Z_Arunachal isn’t about escaping work—it’s about rediscovering the power of people, purpose, and place.</p>
                        <p>It is a curated networking retreat crafted to foster genuine relationships, collaboration, and growth. Set in the serenity of Shergaon, teams and individuals reconnect through dialogue-driven circles, immersive activities, and mindful pauses that inspire new ways of thinking. It’s where professionals slow down, share openly, and return with stronger networks, clearer vision, and renewed energy.</p>
                        <div className="middle-column">
                            <div className="row clearfix">
                                <div className="column col-lg-6 col-md-12 col-sm-12">
                                    <h3 className="event-detail_subtitle">Key Points of the Event</h3>
                                    <ul className="event-detail_list">
                                        <li>Build authentic networks through shared experiences in a relaxed, natural setting.</li>
                                        <li>Engage in meaningful conversations that go beyond small talk.</li>
                                        <li>Be spotlighted in our gratitude circle and community highlights.</li>
                                        <li>Be part of a movement that blends clarity, collaboration, and mindful networking.</li>
                                    </ul>
                                </div>
                                <div className="column col-lg-6 col-md-6 col-sm-12">
                                    <div className="event-detail_image-two">
                                        <img src="assets/images/resource/event-1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>Z_Arunachal is a rhythm of calm mornings, thoughtful sessions, and evenings of laughter under starry skies. With no formalities and no rush, it’s a space where you meet not just new contacts but collaborators, mentors, and friends. It’s networking redefined—personal, purposeful, and profoundly human.</p>
                        <div className="appointmeny_button-box" style={{ textAlign: 'center', margin: '30px 0' }}>
                            <button
                                type="button"
                                className="theme-btn btn-style-one"
                                disabled
                                aria-disabled="true"
                                style={{ cursor: 'not-allowed', opacity: 0.6 }}
                            >
                                <span className="btn-wrap">
                                    <span className="text-one">Coming Soon</span>
                                    <span className="text-two">Coming Soon</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            {/* <Subscribe2 /> */}
            <VenueSection1 />
            <Footer2/>
            <Scrollbar />
        </Fragment>
    )
};
export default EventSinglePage;
